if(!customElements.get('upsell-add-to-cart-button')){
    class UpsellAddToCartButton extends HTMLElement{
        constructor(){
            super();
            this.button = this.querySelector('button');
            this.buttonTextContainer = this.button.querySelector('span');
            this.loadingSpinner = this.querySelector('.loading-spinner');
            this.productId = this.dataset.productId;
            this.quantity = this.dataset.quantity;
            this.cartDrawer = this.closest('cart-drawer');
        }
        connectedCallback(){
            this.button.addEventListener('click',async () => await this.handleClick());
        }
        async handleClick(){
            if(this.productId != this.dataset.productId){
                this.productId = this.dataset.productId;
            }
            this.showSpinner();
            await this.addToCart(this.productId, this.quantity);
            await this.updateCartDrawer();
        }
        showSpinner(){
            this.buttonTextContainer.textContent = '';
            this.button.classList.add('loading');
        }
        async addToCart(bundleProductId, quantity) {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    items: [{
                        id: parseInt(bundleProductId, 10),
                        quantity: quantity
                    }]
                })
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.description || 'Error adding item to cart');
            }

            return response.json();
        }

        async updateCartDrawer() {
            if (!this.cartDrawer) return;

            const response = await fetch(
                `${window.Shopify.routes.root}cart?sections=cart-drawer,cart-icon-bubble`
            );
            const sectionsData = await response.json();

            this.cartDrawer.renderContents({ sections: sectionsData });
        }
    }

    customElements.define('upsell-add-to-cart-button', UpsellAddToCartButton);
}
